<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0 " v-if="!stub">

            <div class="d-flex flex-column flex-xl-row w-100 align-items-start justify-content-start mb-5">

                <div class="d-flex flex-grow-1 align-items-xl-center mb-4 mb-xl-0 flex-column flex-sm-row w-100">
                    <b-button
                            variant="link"
                            class="flex-grow-0 d-flex align-items-center text-secondary flex-nowrap p-0 mb-4"
                            @click="back()">
                        <b-icon icon="chevron-left" class="mr-2"/>
                        <span>Назад</span>
                    </b-button>

                    <div class="d-flex flex-grow-1 align-items-baseline justify-content-center flex-column flex-sm-row mb-4"
                         :key="objectKey + '-header'">
<!--                        <span class="h3 mb-2 mb-lg-0" v-if="!object.id">{{ groupTitle }}</span>-->
                        <span class="h3 mb-2 mb-lg-0 mr-3">{{ header }}</span>
                        <sup><small v-if="!object.id" class="text-secondary ml-2">Новая</small></sup>
                    </div>
                </div>
            </div>

            <div id="form" class="d-flex flex-wrap">

                <form-field  class="col-xs-12 col-lg-6 col-xl-3 required mb-3"
                             :label="getFieldLabel('name')"
                             :editable="getAbility('name')"
                             :value="object.name"
                             :feedback="liveFeedback('name')">
                    <template #field>
                        <b-form-input
                            id="name"
                            class="w-100"
                            type="text"
                            v-model="$v.form.name.$model"
                            :state="validateState('name')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field  class="col-xs-12 col-lg-4 col-xl-3 mb-3"
                             :label="getFieldLabel('shortName')"
                             :editable="getAbility('shortName')"
                             :value="object.shortName"
                             :feedback="liveFeedback('shortName')">
                    <template #field>
                        <b-form-input
                            id="shortName"
                            class="w-100"
                            type="text"
                            v-model="$v.form.shortName.$model"
                            :state="validateState('shortName')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field  class="col-xs-12 col-lg-4 col-xl-3 mb-3"
                             :label="getFieldLabel('email')"
                             :editable="getAbility('email')"
                             :value="object.email"
                             :feedback="liveFeedback('email')">
                    <template #field>
                        <b-form-input
                            id="email"
                            class="w-100"
                            type="text"
                            v-model="$v.form.email.$model"
                            :state="validateState('email')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field  class="col-xs-12 col-lg-3 required mb-3"
                             :label="getFieldLabel('inn')"
                             :editable="getAbility('inn')"
                             :value="object.inn"
                             :feedback="liveFeedback('inn')">
                    <template #field>
                        <b-form-input
                            id="inn"
                            class="w-100"
                            type="text"
                            v-model="$v.form.inn.$model"
                            :state="validateState('inn')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field  class="col-xs-12 col-lg-3 mb-3"
                             :label="getFieldLabel('ogrn')"
                             :editable="getAbility('ogrn')"
                             :value="object.ogrn"
                             :feedback="liveFeedback('ogrn')">
                    <template #field>
                        <b-form-input
                            id="ogrn"
                            class="w-100"
                            type="text"
                            v-model="$v.form.ogrn.$model"
                            :state="validateState('ogrn')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field :label="getFieldLabel('groupList')"
                            class="col-xs-12 col-lg-10 col-xl-8 mb-3 required"
                            :editable="getAbility('groupList') && canEditServiceInfo"
                            :feedback="liveFeedback('groupList')"
                            :value="object.groupTexts"
                            :key="objectKey + 'groups'">
                    <template #field>
                        <list-select name="groupList"
                                     v-model="form['groupObjects']"
                                     :url="groupsUrl"
                                     :label="getFieldLabel('groupList')"
                                     :state="getValidationClass('groupList')"
                                     :initial-filters="groupInitialFilters"
                                     can-remove-key="can_remove"
                                     :has-search="false"
                                     v-on:select-added="onModelObjectListAdded"
                                     v-on:select-removed="onModelObjectListRemoved"  />
                    </template>
                </form-field>

                <form-field :label="getFieldLabel('activityList')"
                            class="col-xs-12 col-lg-10 col-xl-8 mb-3 required value-bg-info"
                            :editable="getAbility('activityList') && canEditServiceInfo"
                            :feedback="liveFeedback('activityList')"
                            :value="object.activityTexts"
                            :key="objectKey + 'activities'">
                    <template #field>
                        <list-select name="activityList"
                                     v-model="form['activityObjects']"
                                     :url="activitiesUrl"
                                     :label="getFieldLabel('activityList')"
                                     :state="getValidationClass('activityList')"
                                     :has-search="false"
                                     v-on:select-added="onModelObjectListAdded"
                                     v-on:select-removed="onModelObjectListRemoved" />
                    </template>
                </form-field>

                <form-field v-if="hasMunicipalityRestrictions"
                            :label="getFieldLabel('municipalities')"
                            class="col-xs-12 col-lg-10 col-xl-8 mb-3 required"
                            :editable="getAbility('municipalities') && canEditServiceInfo"
                            :feedback="liveFeedback('municipalities')"
                            :value="object.municipalityTexts"
                            :key="objectKey + 'municipalities'">
                    <template #field>
                        <list-select name="municipalities"
                                     v-model="form['municipalityObjects']"
                                     :url="municipalitiesUrl"
                                     :label="getFieldLabel('municipalities')"
                                     :state="getValidationClass('municipalities')"
                                     :initial-filters="municipalityInitialFilters()"
                                     label-key="short_name"
                                     v-on:select-added="onModelObjectListAdded"
                                     v-on:select-removed="onModelObjectListRemoved" />
                    </template>
                </form-field>

                <form-field  class="col-xs-12 col-lg-6 mb-3"
                             :label="getFieldLabel('workHours')"
                             :editable="getAbility('workHours')"
                             :value="object.workHours"
                             :feedback="liveFeedback('workHours')">
                    <template #field>
                        <b-form-input
                            id="workHours"
                            class="w-100"
                            type="text"
                            v-model="$v.form.workHours.$model"
                            :state="validateState('workHours')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field  class="col-xs-12 col-lg-4 mb-3"
                             :label="getFieldLabel('phone')"
                             :editable="getAbility('phone')"
                             :value="object.phone"
                             :feedback="liveFeedback('phone')">
                    <template #field>
                        <b-form-input
                            id="phone"
                            class="w-100"
                            type="text"
                            v-model="$v.form.phone.$model"
                            :state="validateState('phone')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field  class="col-xs-12 col-lg-6 mb-3 mr-3"
                             :label="getFieldLabel('website')"
                             :editable="getAbility('website')"
                             :value="object.website ? 'https://' + object.website : null"
                             :feedback="liveFeedback('website')">
                    <template #field>
                      <b-input-group prepend="https://">
                        <b-form-input  id="website"
                            type="text"
                            v-model="$v.form.website.$model"
                            :state="validateState('website')"></b-form-input>
                      </b-input-group>
                    </template>
                </form-field>

                <form-field v-if="isInController && !isMunicipalController" class="col-xs-12 col-sm-6 col-md-3 col-lg-2 p-0 mr-3 mt-3"
                        :label="getFieldLabel('publish')"
                        :value="object.publish ? 'Да' : 'Нет'"
                        :editable="true"
                        :feedback="liveFeedback('publish')">
                    <template #field>
                        <b-form-checkbox  size="lg" v-model="form.publish" @change="onPublishChange" switch >
                            <span v-if="form.publish">Да</span>
                            <span v-else>Нет</span>
                        </b-form-checkbox>
                    </template>
                </form-field>


                <form-field
                    :label="getFieldLabel('address')"
                    class="col-xs-12 col-lg-10 col-xl-6 m-2"
                    :editable="getAbility('address')"
                    :feedback="liveFeedback('address')"
                    :value="form.addressHumanReadable ? form.addressHumanReadable : 'Не указан'">

                    <template #value>
                        <map-box ref="map" :coordinates="selectedCoordinates" style="width: 100%; height: 500px"/>
                        <div class="clearfix p-1"></div>
                        <div class="col-12 p-0 m-0 d-flex align-items-center">
                            <div class="flex-grow-1 mr-2">{{ form.addressHumanReadable ? form.addressHumanReadable : 'Не указан' }}</div>
                            <b-button variant="link" class="p-0" @click="onAddressFocus">
                                <img :src="focus" width="32"/>
                            </b-button>
                        </div>
                    </template>

                    <template #field>
                        <div class="clearfix p-1"></div>
                        <map-box ref="map"
                                 :coordinates="selectedCoordinates"
                                 :center-lat="selectedMunicipality ? parseFloat(selectedMunicipality.lat) : 68.9614"
                                 :center-lon="selectedMunicipality ? parseFloat(selectedMunicipality.lon) : 33.0955"
                                 v-on:map-clicked="onMapClicked" style="width: 100%; height: 500px"/>
                        <div class="clearfix p-1"></div>
                        <div class="col-12 p-0 m-0 d-flex">
                            <single-select name="address"
                                           ref="address"
                                           class="flex-grow-1 mr-2"
                                           v-model="form['addressObject']"
                                           :url="getAddressUrl"
                                           :label="getFieldLabel('address')"
                                           label-key="short_text"
                                           :state="getValidationClass('address')"
                                           :has-pagination="false"
                                           :initial-filters="addressInitialFilters"
                                           placeholder="Поиск адреса"
                                           v-on:select-search-init="onAddressSearchStart"
                                           v-on:select-changed="onAddressChanged"
                                           v-on:select-set="onAddressSet"
                                           v-on:select-cleared="onModelObjectSingleSelectCleared" />
                            <b-button variant="link" class="p-0" @click="onAddressFocus">
                                <img :src="focus" width="32"/>
                            </b-button>
                        </div>
                    </template>
            </form-field>


            <form-field
                    :label="getFieldLabel('legalAddress')"
                    class="col-xs-12 col-lg-10 col-xl-6 m-2"
                    :editable="getAbility('legalAddress')"
                    :feedback="liveFeedback('legalAddress')"
                    :value="form.legalAddress">

                    <template #field>
                        <b-textarea
                            id="legalAddress"
                            class="w-100"
                             v-model="$v.form.legalAddress.$model"
                            :state="validateState('legalAddress')">
                        </b-textarea>
                    </template>
            </form-field>

            </div>

            <div class="col-12">
                <object-form-buttons :has-changes="hasChanges"
                     :object-exists="Boolean(object.id)"
                     @object-create="onCreate"
                     @object-update="updateObject"
                     @object-cancel-changes="cancelChanges" class="mb-5"/>
            </div>

        </b-card>

        <stub v-else :failed-loading="failedLoading"/>

        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>
    </div>
</template>

<script>
import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
import FormField from "@/components/Forms/FormField";
import api from "@/api";
import {Organization} from "@/pages/AppPages/Catalogs/Organizations/organization";
import ConfirmLeaveModal from "@/components/Forms/ConfirmLeaveModal";
import ObjectFormButtons from "@/components/Forms/ObjectFormButtons";
import ListSelect from "@/components/Select/ListSelect";
import SingleSelect from "@/components/Select/SingleSelect";
import {mapGetters} from "vuex";
import {ACTIVITIES, USER_GROUPS} from "@/store/auth/auth";
import Stub from "@/components/Stub.vue";
import {MapMixin} from "@/components/Map/mapMixin";
import MapBox from "@/components/Map/MapBox.vue";
import MapMunicipalityList from "@/components/Map/MapMunicipalityList.vue";

export default {
    name: "OrganizationDetail",
    components: {
      MapMunicipalityList,
      MapBox, Stub, SingleSelect, ListSelect, ObjectFormButtons, ConfirmLeaveModal, FormField},
    mixins: [ ObjectComponentMixin, MapMixin ],
    props: {
        organizationId: {},
        // initialGroups: { type: Array },
    },
    data() {
        return {
            initialGroups: [1, 2, 4, 8],
            initialMunicipalities: [],
        }
    },
    validations() {
        if (this.isMunicipalityGroupChosen()) {
            return {form: this.objectClass.municipalityValidations}
        }
        return this.objectClass ? {form: this.objectClass.validations} : {}
    },
    computed: {
        ...mapGetters(['isMunicipalController', 'isInController', 'userOrganizationActivities',
            'userOrganizationMunicipalities', 'userOrganizationMunicipalityNames']),
        groupsUrl() {
            return api.organizations.groups.list();
        },
        activitiesUrl() {
            return api.organizations.activities.list();
        },
        municipalitiesUrl() {
            return api.municipalities.default.list()
        },
        groupInitialFilters() {
            let filters = [];
            for (const group of this.initialGroups) {
                filters.push({ key: 'id', value: group })
            }
            return filters
        },
        hasMunicipalityRestrictions() {
          return this.form.groupList && this.form.groupList.length && this.form.groupList.includes(USER_GROUPS.MUNICIPALITY)
        },
        canEditServiceInfo() {
          return this.isInController && !this.hasMunicipalityRestrictions && this.userOrganizationActivities.includes(ACTIVITIES.CONTROL)
        }
    },
    methods: {
        isMunicipalityGroupChosen() {
            return this.form.groupList && this.form.groupList.length && this.form.groupList.includes(USER_GROUPS.MUNICIPALITY)
        },
        municipalityInitialFilters() {
            let filters = [];
            for (const m of this.initialMunicipalities) {
                filters.push({ key: 'mun_id', value: m })
            }
            return filters
        },
        onPublishChange() {
            this.$v.form.publish.$touch();
        },

    },
    beforeMount() {
        this.objectClass = Organization;
        this.objectId = this.organizationId ? this.organizationId : this.$route.params.id;
        this.apiEntryPoint = api.organizations;

        this.backRoute = 'organizationList';
        this.nextRoute = 'organizationDetail';

        if (this.isMunicipalController) {
            this.initialGroups = [4, 8]
        }

        if (this.isInController && !this.isMunicipalController) {
            this.initialGroups = [1, 2, 8]
        }

        if (this.isMunicipalController) {
            this.initialMunicipalities = this.userOrganizationMunicipalities
            this.initObjectParams['municipalities'] = this.userOrganizationMunicipalities;
            this.initObjectParams['municipalityObjects'] = this.userOrganizationMunicipalityNames;
            this.initObjectParams['groupList'] = [2]
            this.initObjectParams['excludeGroups'] = [2]
        }

    },
    mounted() {
        const vm = this;
        vm.onMount();
        vm.resetForm().then(() => {
            if (vm.object.addressObject['id']) {
                vm.setMapCoordinates(vm.object.coordinates)
            }
        });
    },
}
</script>

<style scoped>

</style>